<proffeo-ui-dialog [title]="'task-filters.filters' | translate">
  <div class="flex min-w-0 w-full flex-col gap-5">
    <section class="flex min-w-0 w-full flex-col gap-3">
      <h3 class="proffeo-ui-text-muted">{{ 'task-filters.sections.sort' | translate }}</h3>
      <proffeo-task-sort-controls class="min-w-0 w-full" />
    </section>

    <proffeo-task-filters-advanced class="min-w-0 w-full" />
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end"
  >
    <proffeo-ui-button
      (clicked)="close()"
      text="close"
    />
  </div>
</proffeo-ui-dialog>
